import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyPlanForeseeableRescueScenariosSection({ section, plan = {}, sectionNumber = 3 }) {
  const displayName = section && section.display_name
    ? section.display_name
    : "Foreseeable Rescue Scenarios";
  const procedures = Array.isArray(plan.linked_documents)
    ? plan.linked_documents.filter((procedure) => (
      procedure
      && procedure.checked === true
      && procedure.procedure_application
      && procedure.procedure_application.toggle === 1
    ))
    : [];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`} style={{ background: "#e9c84a", color: "#1f1031" }}>
          {sectionNumber}
        </span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <table className={`${styles.PreviewTable} ${styles.EmergencyPlanScenarioTable}`}>
          <thead className={styles.EmergencyPlanScenarioTableHead}>
            <tr>
              <th style={{ width: "35%" }}>Forseeable Situation</th>
              <th style={{ width: "30%" }}>Applicable Rescue Procedure</th>
              <th style={{ width: "35%" }}>Selection / Escalation Rule</th>
            </tr>
          </thead>
          <tbody>
            {procedures.map((procedure, index) => {
              const application = procedure.procedure_application.data || {};
              const scenario = application.scenario && application.scenario.text ? application.scenario.text : "";
              const objective = application.objective && application.objective.text ? application.objective.text : "";

              return (
                <tr key={procedure.document_number || procedure.procedure_id || index}>
                  <td><div>{scenario}</div></td>
                  <td>
                    <div style={{ fontSize: "12px", fontWeight: 700 }}>{procedure.document_number || <span>&mdash;</span>}</div>
                    <div>{procedure.procedure_title || <span>&mdash;</span>}</div>
                  </td>
                  <td><div>{objective}</div></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
